import React, { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

export default function HeaderNavbar({ visibleSections = [], isLoggedIn }) {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    if (expanded) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [expanded]);

  const handleNavClick = () => setExpanded(false);

  return (
    <Navbar
      expanded={expanded}
      onToggle={() => setExpanded((prev) => !prev)}
      expand="lg"
      className="header-nav customeheader p-0"
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />

      <Navbar.Collapse id="responsive-navbar-nav" className="mobile-slide">
       {<button type="button" className="menu-close " onClick={() => setExpanded(false)} aria-label="Close menu">
          &times;
        </button>}

        <Nav className="me-auto">
          {visibleSections.includes("home") && (
            <Nav.Link as={Link} to="/home" className={path === "/home" ? "active" : ""} onClick={handleNavClick}>
              Home
            </Nav.Link>
          )}

          {visibleSections.includes("aboutUs") && (
            <Nav.Link
              as={Link}
              to="/about-us"
              className={path === "/about-us" ? "active" : ""}
              onClick={handleNavClick}
            >
              About us
            </Nav.Link>
          )}

          {visibleSections.includes("explore") && (
            <Nav.Link as={Link} to="/explore" className={path === "/explore" ? "active" : ""} onClick={handleNavClick}>
              Explore
            </Nav.Link>
          )}

          {visibleSections.includes("contactUs") && (
            <Nav.Link as={Link} to="/contact" className={path === "/contact" ? "active" : ""} onClick={handleNavClick}>
              Contact
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

/*
//   CSS (put into your component CSS / global scss):

//   @media (max-width: 991.98px) {
//     .navbar-collapse.mobile-slide {
//       position: fixed;
//       top: 0;
//       left: -260px;        /* hidden to the left */
//       width: 260px;
//       height: 100%;
//       background: #fff;
//       padding: 2rem 1rem 1rem;
//       transition: left 0.28s ease-in-out;
//       z-index: 1050;       /* above most content */
//       box-shadow: 2px 0 8px rgba(0,0,0,0.12);
//     }

//     /* Bootstrap adds the .show class when collapsed opens */
//     .navbar-collapse.mobile-slide.show {
//       left: 0;
//     }

//     .navbar-collapse.mobile-slide .menu-close {
//       position: absolute;
//       top: 12px;
//       right: 14px;
//       font-size: 1.8rem;
//       border: none;
//       background: transparent;
//       cursor: pointer;
//       line-height: 1;
//     }
//   }

//   Notes / Tips:
//   1) DON'T mix React-Bootstrap's controlled component approach with Bootstrap's data-* JS (data-bs-toggle, etc.). That desynchronizes state and causes the "can't open after closing" bug.
//   2) If you were previously using data-bs-* on the close button or nav-links, remove those attributes and use the onClick handlers shown above.
//   3) If you're using React-Bootstrap, you generally do NOT need to include Bootstrap's JS bundle (bootstrap.bundle.min.js). Keep only the CSS import: import 'bootstrap/dist/css/bootstrap.min.css';
//   4) If you want the menu to slide from the right instead, change `left: -260px` / `left: 0` to `right: -260px` / `right: 0` and adjust the close button placement.
// */
